webpackJsonp([114276838955818,60335399758886],{

/***/ 227:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(268);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(227);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 290:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hvml-logo.21a543d6.png";

/***/ }),

/***/ 453:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hvml-logo@2x.cfa848c1.png";

/***/ }),

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hvml-logo@3x.d52e1e7c.png";

/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(186);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _typography = __webpack_require__(70);
	
	__webpack_require__(290);
	
	__webpack_require__(292);
	
	__webpack_require__(291);
	
	var _hvmlLogo = __webpack_require__(452);
	
	var _hvmlLogo2 = _interopRequireDefault(_hvmlLogo);
	
	var _hvmlLogo2x = __webpack_require__(453);
	
	var _hvmlLogo2x2 = _interopRequireDefault(_hvmlLogo2x);
	
	var _hvmlLogo3x = __webpack_require__(454);
	
	var _hvmlLogo3x2 = _interopRequireDefault(_hvmlLogo3x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import 'prismjs/themes/prism-solarizedlight.css'
	
	// import './themes/prism-mods/solarizedlight.css'
	
	
	// import 'prism-themes/themes/prism-a11y-dark.css'
	// import './themes/dracula-prism/css/dracula-prism.css'
	
	// import 'prismjs/themes/prism-funky.css'
	// import './themes/prism-mods/funky.css'
	
	// import 'prism-themes/themes/prism-duotone-sea.css'
	// import './themes/prism-mods/duotone-sea.css'
	
	// import logo from '../img/hvml-logo.png'
	
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template() {
	    _classCallCheck(this, Template);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Template.prototype.render = function render() {
	    var _props = this.props,
	        location = _props.location,
	        children = _props.children;
	    // let isHomepage = ( location.pathname === rootPath )
	
	    var rootPath = '/';
	    if (false) {
	      rootPath = __PATH_PREFIX__ + '/';
	    }
	
	    var headerContents = function headerContents(size) {
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'h1',
	          { style: {
	              fontSize: size === 'small' ? (0, _typography.rhythm)(1) : undefined,
	              marginTop: 0
	            } },
	          'HVML'
	        ),
	        _react2.default.createElement(
	          'h2',
	          { style: {
	              fontSize: size === 'small' ? (0, _typography.rhythm)(0.777778) : undefined,
	              margin: (0, _typography.rhythm)(0)
	            } },
	          'Hypervideo Markup Language'
	        )
	      );
	    };
	
	    var logo = _react2.default.createElement('img', { className: 'branding__logo', src: _hvmlLogo2.default, width: location.pathname === rootPath ? 152 : 114, height: location.pathname === rootPath ? 152 : 114, srcSet: _hvmlLogo2.default + ' 1x, ' + _hvmlLogo2x2.default + ' 2x, ' + _hvmlLogo3x2.default + ' 3x', style: {
	        borderRadius: '101px',
	        margin: '0 auto'
	      } });
	
	    var header = _react2.default.createElement(
	      'hgroup',
	      { className: 'branding__name', style: _extends({}, (0, _typography.scale)(1.5), {
	          marginTop: '-13px'
	        }) },
	      location.pathname === rootPath ? headerContents() : headerContents('small')
	    );
	
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            marginLeft: 'auto',
	            marginRight: 'auto',
	            // maxWidth: rhythm(24.68355),
	            width: '39rem',
	            maxWidth: '80%',
	            padding: (0, _typography.rhythm)(1.5) + ' 0' // ${rhythm(3 / 4)}
	          }
	        },
	        _react2.default.createElement(
	          'header',
	          { className: 'branding', style: {
	              marginBottom: (0, _typography.rhythm)(1.5)
	            } },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              className: 'homepage-link',
	              style: {
	                boxShadow: 'none',
	                textDecoration: 'none',
	                color: 'inherit',
	                backgroundImage: 'none'
	              },
	              to: '/'
	            },
	            logo
	          ),
	          header
	        ),
	        children(),
	        _react2.default.createElement(
	          'footer',
	          { style: _extends({
	              textAlign: 'center'
	            }, (0, _typography.scale)(0.00625), {
	              marginTop: (0, _typography.rhythm)(3),
	              marginBottom: (0, _typography.rhythm)(-.75),
	              lineHeight: 1.5
	            }) },
	          _react2.default.createElement(
	            'p',
	            { style: {
	                fontSize: '0.95rem',
	                marginBottom: (0, _typography.rhythm)(0.333333)
	              } },
	            _react2.default.createElement(
	              'a',
	              { href: 'https://github.com/RedBlueVideo/hvml-spec' },
	              'GitHub'
	            ),
	            ' | ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://twitter.com/HypervideoML' },
	              'Twitter'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'small',
	              null,
	              'Copyright \xA9 ',
	              function () {
	                var year = new Date().getFullYear();
	                // console.log( )
	                if (year > 2018) {
	                  return '2018\u2014' + year;
	                }
	                return year;
	              }(),
	              ' HVML Working Group (',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://hughguiney.com' },
	                'Hugh Guiney'
	              ),
	              ' ',
	              _react2.default.createElement(
	                'abbr',
	                { title: 'and others' },
	                'et al.'
	              ),
	              ').'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'small',
	              null,
	              'This work is licensed under the ',
	              _react2.default.createElement(
	                'a',
	                { rel: 'license', href: 'https://github.com/RedBlueVideo/hvml-spec/blob/master/LICENSE.txt' },
	                _react2.default.createElement(
	                  'abbr',
	                  null,
	                  'GNU'
	                ),
	                ' General Public License v3.0'
	              ),
	              '.'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Template;
	}(_react2.default.Component);
	
	exports.default = Template;
	module.exports = exports['default'];

/***/ }),

/***/ 291:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 292:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-d69573f85cd6e49e03c9.js